import React from 'react';
import '../less/repair.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import { eVidnovlenniaCardTerms } from '../../../../services/urls/urls';
import InfoBlock from '../../../../auxiliary-components/shared/InfoBlock';
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import tariffsData from '../enums/tariffs_data.json';
import additionalCards from '../enums/additional_cards_data.json'
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'eVidnovlennia-card-new';

    const hero_data = {
      title: 'REPAIR_CARD_NEW_HERO_TITLE',
      text: 'REPAIR_CARD_NEW_HERO_TEXT',
      link: {
        text: "REPAIR_CARD_NEW_HERO_BTN",
        onClick: () => this.toggleModal(),
      },
      cards: [
        {
          title: 'REPAIR_CARD_NEW_CARDS_HERO_TITLE_01',
          text: 'REPAIR_CARD_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'REPAIR_CARD_NEW_CARDS_HERO_TITLE_02',
          text: 'REPAIR_CARD_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'REPAIR_CARD_NEW_CARDS_HERO_TITLE_03',
          text: 'REPAIR_CARD_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    };

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
        <div className="module-repair-new">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
                <InfoBlock 
                  title={'REPAIR_CARD_NEW_INFO_TITLE'}
                  text={'REPAIR_CARD_NEW_INFO_TEXT'}
                  headText={'REPAIR_CARD_NEW_INFO_TITLE_HEAD'}
                />
                <AdvantagesAdmin
                  data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
                  loader={this.state.loader}
                />
                <Tariffs
                  items={tariffsData}
                  title={'REPAIR_CARD_NEW_CARDS_TARIFFS_TITLE'}
                  btnLink={eVidnovlenniaCardTerms}
                  btnText={'REPAIR_CARD_NEW_CARDS_TARIFFS_BTN'}
                  page={page}
                />
                <AdditionalProduct
                  items={additionalCards}
                  title={'REPAIR_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                  page={page}
                />
                <QuestionsAdminNew
                  widget={questionsWidget}
                  toggleFaqTab={this.toggleFaqTab}
                  title={'FAQ_SHORT_NEW_TITLE'}
                  page={page}
                />
                <FilesForDownloadNew
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />
                <TextAboveFooterNew
                  widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
                />
              </>
            ) : (
              <FAQStorybook
                widget={questionsWidget}
                title={this.l10n('REPAIR_CARD_NEW_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('REPAIR_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
              />
            )}
          </div>
          {this.state.showModal ? 
            <CardOrderModal closeModal={this.toggleModal} product={"eVidnovlennia"} isOpen={this.state.showModal}/> : ''
          }
        </div>
    );
}
